import { EventType } from '@/analytics/types';
import type { LandingPageScrollFeatureTabProps } from '@/app/components/LandingPage/LandingPageScrollFeatures/LandingPageScrollFeatureTabs';

export const partnershipOfferingsData: LandingPageScrollFeatureTabProps[] = [
  {
    title: 'partnerships_offerings_api',
    copy: 'partnerships_offerings_api_copy',
    image: '/blue-sky/partnerships/features-api.png',
    imageAlt: 'partnerships_offering_oura_api_alt',
    actionLabel: 'partnerships_offerings_api_action',
    actionOnClick: () => {
      const pathname = new URL('https://cloud.ouraring.com/v2/docs');

      void window.ouraAnalytics.track(EventType.LinkClicked, {
        cta: 'request_a_demo',
        location: 'partnerships hero',
        path: pathname,
      });

      window.open(pathname, '_blank');
    },
  },
  {
    title: 'partnerships_offerings_apple_or_google',
    copy: 'partnerships_offerings_apple_or_google_copy',
    image: '/blue-sky/partnerships/features-integrations.png',
    imageAlt: 'partnerships_offering_apple_google_alt',
  },
  {
    title: 'partnerships_offerings_affiliates',
    copy: 'partnerships_offerings_affiliates_copy',
    image: '/blue-sky/partnerships/features-affiliates.png',
    imageAlt: 'partnerships_offerings_affiliates_alt',
    actionLabel: 'apply_for_partner_program',
    actionOnClick: () => {
      const pathname = new URL('https://partners.ouraring.com/');

      void window.ouraAnalytics.track(EventType.LinkClicked, {
        cta: 'request_a_demo',
        location: 'partnerships hero',
        path: pathname,
      });

      window.open(pathname, '_blank');
    },
  },
  {
    title: 'partnerships_offerings_brand',
    copy: 'partnerships_offerings_brand_copy',
    image: '/blue-sky/partnerships/features-equinox.png',
    imageAlt: 'partnerships_offerings_brand_alt',
  },
];
